module.exports = __webpack_public_path__ + "static/media/NotoSans-Bold.6a1f7cfe.ttf";